import uniq from 'lodash-es/uniq';
const defaultFields = ['fuelType', 'horsePower', 'mainTypeSub', 'gearType', 'doorCount'];
export function useSplitFieldsProps() {
  let fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultFields;
  return {
    createSteps: [function splitFieldsSteps(_ref) {
      let [step1] = _ref;
      return [uniq(step1.concat(fields))];
    }],
    createCustomValidators: [function leadSplitValidator(_ref2) {
      let {
        validators
      } = _ref2;
      return { ...validators,
        ...fields.reduce((acc, field) => {
          acc[field] = _ref3 => {
            let {
              value,
              errorMessages
            } = _ref3;
            return [null, undefined, ''].includes(value) ? errorMessages[field] : true;
          };

          return acc;
        }, {})
      };
    }]
  };
}